import sys from "./sys"

export default `
  ${sys}
  url
  title
  width
  height
  description
  contentType
`
